import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { VideoPlayerComponent } from '../../../../shared/components/video-player/video-player.component';
import { HeaderBannerComponent } from '../../../../shared/components/header-banner/header-banner.component';
import { SearchFieldComponent } from '../../../../shared/components/forms/search-field/search-field.component';
import { TagFilterComponent } from '../../../../shared/components/forms/tag-filter/tag-filter.component';
import { VideosSearchOptions } from '../../../../shared/components/forms/search-field/search-utils';
import { HttpParams } from '@angular/common/http';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { HowtoVideoApiService } from '../../../../_services/howto-video-service/howto-video-api.service';
import { Video, VideoTag } from '../../../../_interfaces/howto-video';
import { ActivatedRoute, Router } from '@angular/router';
import { updateParamsObject } from '../../../../shared/utils/filter-utils';
import { Subscription } from 'rxjs';
import { BoFormsModule } from '@bo/ng-forms';
import { calcShowPage } from '../../../../shared/utils/general-utils';
import { NgClass } from '@angular/common';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';

@Component({
  selector: 'app-how-to-videos',
  imports: [
    VideoPlayerComponent,
    HeaderBannerComponent,
    SearchFieldComponent,
    TagFilterComponent,
    PaginationModule,
    BoFormsModule,
    NgClass,
    LoaderComponent,
  ],
  templateUrl: './how-to-videos.component.html',
  styleUrl: '../../../../../static/styles/components/how-to-videos.scss',
})
export class HowToVideosComponent implements OnInit, OnDestroy {
  readonly howtoVideoApiService = inject(HowtoVideoApiService);
  readonly route = inject(ActivatedRoute);
  readonly router = inject(Router);

  protected readonly videosSearchOptions = VideosSearchOptions;
  params = new HttpParams();
  count: number = 0;
  page_size: number = 9;
  page: number = 1;
  rowNumber: number = 0;
  totalShown: number = 0;
  isLoading: boolean = true;
  videoData: Video[] | undefined;
  videoTags: VideoTag[] | undefined;
  private readonly subscriptions = new Subscription();

  ngOnInit() {
    this.subscriptions.add(
      this.route.queryParams.subscribe((queryParams) => {
        // Update component state from URL params
        this.page = queryParams['page'] ? Number(queryParams['page']) : 1;
        this.page_size = queryParams['page_size'] ? Number(queryParams['page_size']) : 9;

        // Check if page and page_size are missing from URL
        const needsPageParam = !queryParams['page'];
        const needsPageSizeParam = !queryParams['page_size'];

        if (needsPageParam || needsPageSizeParam) {
          // Add missing params to URL on initialization
          this.params = new HttpParams().appendAll(queryParams);
          this.params = this.params.set('page', this.page.toString()).set('page_size', this.page_size.toString());

          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: updateParamsObject(this.params),
            replaceUrl: true, // Replace URL to avoid adding to browser history
          });
        } else {
          // Params already exist, just fetch videos
          this.params = new HttpParams().appendAll(queryParams);
          this.getVideos(this.params);
        }
      }),
    );
    this.getVideoTags();
  }

  calcShowPage() {
    const pageOffset = this.page - 1;
    const result = calcShowPage(pageOffset, this.page_size, this.count);
    this.rowNumber = result.rowNumber;
    this.totalShown = result.totalShown;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getVideos(params: HttpParams) {
    this.isLoading = true;
    this.howtoVideoApiService.getHowtoVideos(params).subscribe({
      next: (res) => {
        this.videoData = res.results;
        this.count = res.count;
        this.calcShowPage();
        this.isLoading = false;
      },
    });
  }

  getVideoTags() {
    this.subscriptions.add(
      this.howtoVideoApiService.getHowtoVideoTags().subscribe({
        next: (res) => {
          this.videoTags = res;
        },
      }),
    );
  }

  onChange(event: { page: number; itemsPerPage: number }) {
    this.page = event.page;
    this.page_size = event.itemsPerPage;

    // Get current query params and update page/page_size
    const currentParams = this.route.snapshot.queryParams;
    this.params = new HttpParams().appendAll(currentParams);
    this.params = this.params.set('page', this.page.toString()).set('page_size', this.page_size.toString());

    this.calcShowPage();
    // Update URL query params
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: updateParamsObject(this.params),
    });
  }
}
